import ClickmeetingAccessButton from './ClickmeetingAccessButton';

export default ClickmeetingAccessButton;
